import PropTypes from 'prop-types'
import React from 'react'

import { GOODS_TYPES } from 'constants/sales'
import { LocalizationContext } from 'contexts/Localization'

import WForeverBox from './components/WForeverBox'
import { BarWrapper, WForeverBoxWrapper, Bar } from './styles'

const { wgs, dna } = GOODS_TYPES

const BarAndBox = props => {
  const { paths } = React.useContext(LocalizationContext)
  const { productType, text, isAnimationActive, isMobile } = props
  const imagesName = {
    [wgs]: 'wgs-left-new',
    [dna]: 'dna-left-new',
  }

  return (
    <BarWrapper {...{ productType }}>
      <Bar {...{ isAnimationActive }} />

      <WForeverBoxWrapper {...{ isAnimationActive }}>
        <WForeverBox
          image={`${paths.cdn_boxes}/${imagesName[productType]}`}
          isTextBottom={productType === wgs && !isMobile}
          isWgs={productType === wgs}
          text={text}
        />
      </WForeverBoxWrapper>
    </BarWrapper>
  )
}

BarAndBox.propTypes = {
  productType: PropTypes.oneOf([wgs, dna]).isRequired,
  text: PropTypes.object,
  isAnimationActive: PropTypes.bool,
  isMobile: PropTypes.bool,
}

BarAndBox.defaultProps = {
  text: '',
  isAnimationActive: false,
  isMobile: false,
}

export default BarAndBox
